export var SWAP_ROUTER_ADDRESS = '0xE592427A0AEce92De3Edee1F18E0157C05861564';
export var SWAP_ROUTER_02_ADDRESS = '0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45';
export var SWAP_ROUTER_ADDRESSES = [
    { address: SWAP_ROUTER_ADDRESS, chainId: 1 },
    { address: SWAP_ROUTER_ADDRESS, chainId: 42161 },
    { address: '0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E', chainId: 11155111 },
];
export var SWAP_ROUTER_02_ADDRESSES = [
    { address: SWAP_ROUTER_02_ADDRESS, chainId: 10 },
    { address: '0x2626664c2603336E57B271c5C0b26F421741e481', chainId: 8453 },
];
export var NONFUNGIBLE_POSITION_MANAGER_ADDRESS = '0xC36442b4a4522E871399CD717aBDD847Ab11FE88';
export var NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = [
    { address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS, chainId: 1 },
    { address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS, chainId: 10 },
    { address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS, chainId: 42161 },
    { address: '0x03a520b32C04BF3bEEf7BEb72E919cf822Ed34f1', chainId: 8453 },
    { address: '0x1238536071E1c677A632429e3655c799b22cDA52', chainId: 11155111 },
];
export var FACTORY_ADDRESS = '0x1F98431c8aD98523631AE4a59f267346ea31F984';
export var FACTORY_ADDRESSES = [
    { address: FACTORY_ADDRESS, chainId: 1 },
    { address: FACTORY_ADDRESS, chainId: 10 },
    { address: FACTORY_ADDRESS, chainId: 42161 },
    { address: '0x33128a8fC17869897dcE68Ed026d694621f6FDfD', chainId: 8453 },
    { address: '0x0227628f3F023bb0B980b67D528571c95c6DaC1c', chainId: 11155111 },
];
